import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@observer
class CarFoundModal extends Component {
  state = {
    callDriver: false,
  }

  intervalRefChkOrderStatus = null

  componentDidMount(){
    this.intervalRefChkOrderStatus = setInterval(() => {
      this.props.chkOrderStatus()
    }, 1000)
  }

  componentWillUnmount(){
    clearInterval(this.intervalRefChkOrderStatus)
  }

  callDriver = () => {
    this.setState({
      callDriver: true,
    })
  }

  render() {
    const { carbrand, carcolor, statenumber, driverphone, ordertodatetime } = this.props.foundedCarInfo
    const dateToArrived = new Date(ordertodatetime).getTime() //2020-04-15T19:55:20
    const minutesToArrived = Math.round((dateToArrived - Date.now()) / 1000 / 60)

    const orderRoute = this.props.selectedStreet.map( (street, i) => {
      return (<p key={`${street}-${this.props.selectedHouse[i]}`}>{street} {this.props.selectedHouse[i]}</p>)
    })
 
    return (
      <div className="car_ordering_items">
        <div className="top_row">
          <button className="order_items"><i className="btn-toggle__icon--order close"></i></button>
          <div className="car_found_info">
            <span>{carbrand} - {statenumber} - {carcolor}</span>
          </div>
          <div className="will_arrive">
            {minutesToArrived} мин
          </div>
        </div>
        <div className="rows">
          <div className="middle_row">
            <i className="icon"></i>
            <div className="streets">
              {orderRoute}
            </div>
          </div>
          <div className="bottom_row">
            <button className="btn-cancel" id="order-module-cancel-btn-stage-1">
              <i className="btn-cancel__icon" onClick={this.props.cancelOrder}></i>
              {this.state.callDriver ? 
              (<span className="driver-phone">{driverphone}</span>)
              : (<span className="call-driver" onClick={this.callDriver}>Связаться с водителем</span>)}              
            </button>
          </div>
          <div className="right_column">
            
          </div>
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  selectedStreet: stores.OrderStore.selectedStreet,
  selectedHouse: stores.OrderStore.selectedHouse,
  foundedCarInfo: stores.OrderStore.foundedCarInfo,
  cancelOrder: stores.OrderStore.cancelOrder,
  chkOrderStatus: stores.OrderStore.chkOrderStatus,
}))

export default withData(CarFoundModal);
